import { BLOCK_TIME } from "../constants"

export const FER_PER_BLOCK = Number(process.env.REACT_APP_FER_PER_BLOCK)
export const BLOCKS_PER_YEAR = ((60 * 1000) / BLOCK_TIME) * 60 * 24 * 365
export const FER_PER_YEAR = FER_PER_BLOCK * BLOCKS_PER_YEAR // FIXME fer block per year
